export interface edDeptInfoSlide {
  slideUrl: string;
  id: string;
  additionalInfo: string;
  display: boolean;
}

export const emptySlide: edDeptInfoSlide = {
  additionalInfo: "",
  display: true,
  id: "",
  slideUrl: "",
};
